const shortcodeMap: Record<string, string> = {
  "grinning face": "😀",
  "grinning face with big eyes": "😃",
  "grinning face with smiling eyes": "😄",
  "beaming face with smiling eyes": "😁",
  "grinning squinting face": "😆",
  "grinning face with sweat": "😅",
  "rolling on the floor laughing": "🤣",
  "face with tears of joy": "😂",
  "slightly smiling face": "🙂",
  "upside-down face": "🙃",
  "winking face": "😉",
  "smiling face with smiling eyes": "😊",
  "smiling face with halo": "😇",
  "smiling face with hearts": "🥰",
  "smiling face with heart-eyes": "😍",
  "star-struck": "🤩",
  "face blowing a kiss": "😘",
  "kissing face": "😗",
  "kissing face with closed eyes": "😚",
  "kissing face with smiling eyes": "😙",
  "face savoring food": "😋",
  "face with tongue": "😛",
  "winking face with tongue": "😜",
  "squinting face with tongue": "😝",
  "money-mouth face": "🤑",
  "hugging face": "🤗",
  "face with hand over mouth": "🤭",
  "shushing face": "🤫",
  "thinking face": "🤔",
  "zipper-mouth face": "🤐",
  "face with raised eyebrow": "🤨",
  "neutral face": "😐",
  "expressionless face": "😑",
  "face without mouth": "😶",
  "smirking face": "😏",
  "unamused face": "😒",
  "face with diagonal mouth": "🫤",
  "face with rolling eyes": "🙄",
  "grimacing face": "😬",
  "lying face": "🤥",
  "relieved face": "😌",
  "pensive face": "😔",
  "sleepy face": "😪",
  "drooling face": "🤤",
  "sleeping face": "😴",
  "face with medical mask": "😷",
  "face with thermometer": "🤒",
  "face with head-bandage": "🤕",
  "nauseated face": "🤢",
  "face vomiting": "🤮",
  "sneezing face": "🤧",
  "hot face": "🥵",
  "cold face": "🥶",
  "woozy face": "🥴",
  "dizzy face": "😵",
  "exploding head": "🤯",
  "cowboy hat face": "🤠",
  "partying face": "🥳",
  "disguised face": "🥸",
  "smiling face with sunglasses": "😎",
  "nerd face": "🤓",
  "face with monocle": "🧐",
  "confused face": "😕",
  "worried face": "😟",
  "slightly frowning face": "🙁",
  "frowning face": "☹️",
  "open mouth": "😮",
  "hushed face": "😯",
  "astonished face": "😲",
  "flushed face": "😳",
  "pleading face": "🥺",
  "frowning face with open mouth": "😦",
  "anguished face": "😧",
  "fearful face": "😨",
  "anxious face with sweat": "😰",
  "sad but relieved face": "😥",
  "crying face": "😢",
  "loudly crying face": "😭",
  "face screaming in fear": "😱",
  "confounded face": "😖",
  "persevering face": "😣",
  "disappointed face": "😞",
  "downcast face with sweat": "😓",
  "weary face": "😩",
  "tired face": "😫",
  "yawning face": "🥱",
  "face with steam from nose": "😤",
  "melting face": "🫠",
  "smiling face": "😊",
  "smiling face with tear": "🥲",
  "zany face": "🤪",
  "rolling eyes": "🙄",
  "smiling face with open hands": "🤗",
  "face with party horn and party hat": "🥳",
  "face with open eyes and hand over mouth": "🫢",
  "face with peeking eye": "🫣",
  "saluting face": "🫡",
  "dotted line face": "🫥",
  "face in clouds": "😶‍🌫️",
  "face exhaling": "😮‍💨",
  "face with crossed-out eyes": "😵",
  "face with spiral eyes": "😵‍💫",
  "smiling face with horns": "😈",
  "angry face with horns": "👿",
  "thought balloon": "💭",
  "speech balloon": "💬",
  ghost: "👻",
  alien: "👽",
  "alien monster": "👾",
  robot: "🤖",
  "grinning cat": "😸",
  "grinning cat with smiling eyes": "😺",
  "cat with tears of joy": "😹",
  "smiling cat with heart-eyes": "😻",
  "cat with wry smile": "😼",
  "kissing cat": "😽",
  "weary cat": "🙀",
  "waving hand": "👋",
  "raised back of hand": "🤚",
  "hand with fingers splayed": "🖐️",
  "raised hand": "✋",
  "vulcan salute": "🖖",
  "ok hand": "👌",
  "pinched fingers": "🤌",
  "pinching hand": "🤏",
  "victory hand": "✌️",
  "crossed fingers": "🤞",
  "love-you gesture": "🤟",
  "sign of the horns": "🤘",
  "call me hand": "🤙",
  "backhand index pointing left": "👈",
  "backhand index pointing right": "👉",
  "backhand index pointing up": "👆",
  "middle finger": "🖕",
  "backhand index pointing down": "👇",
  "index pointing up": "☝️",
  "thumbs up": "👍",
  "thumbs down": "👎",
  "raised fist": "✊",
  "oncoming fist": "👊",
  "left-facing fist": "🤛",
  "right-facing fist": "🤜",
  "clapping hands": "👏",
  "raising hands": "🙌",
  "open hands": "👐",
  "palms up together": "🤲",
  handshake: "🤝",
  "folded hands": "🙏",
  "writing hand": "✍️",
  "nail polish": "💅",
  selfie: "🤳",
  "flexed biceps": "💪",
  leg: "🦵",
  foot: "🦶",
  ear: "👂",
  nose: "👃",
  brain: "🧠",
  eyes: "👀",
  eye: "👁️",
  tongue: "👅",
  mouth: "👄",
  "biting lip": "🫦",
  "rightwards hand": "🫱",
  "leftwards hand": "🫲",
  "palm down hand": "🫳",
  "palm up hand": "🫴",
  "hand with index finger and thumb crossed": "🫰",
  "index pointing at the viewer": "🫵",
  "heart hands": "🫶",
  "mechanical arm": "🦾",
  "mechanical leg": "🦿",
  "ear with hearing aid": "🦻",
  "anatomical heart": "🫀",
  baby: "👶",
  child: "🧒",
  boy: "👦",
  girl: "👧",
  person: "🧑",
  man: "👨",
  woman: "👩",
  "older person": "🧓",
  "old man": "👴",
  "old woman": "👵",
  "person blond hair": "👱‍♂️",
  "person beard": "🧔",
  "man beard": "🧔‍♂️",
  "woman beard": "🧔‍♀️",
  "man red hair": "👨‍🦰",
  "monkey face": "🐵",
  monkey: "🐒",
  gorilla: "🦍",
  "dog face": "🐶",
  dog: "🐕",
  poodle: "🐩",
  wolf: "🐺",
  fox: "🦊",
  "cat face": "🐱",
  cat: "🐈",
  lion: "🦁",
  "tiger face": "🐯",
  tiger: "🐅",
  leopard: "🐆",
  "horse face": "🐴",
  horse: "🐎",
  unicorn: "🦄",
  zebra: "🦓",
  deer: "🦌",
  "cow face": "🐮",
  ox: "🐂",
  "water buffalo": "🐃",
  cow: "🐄",
  "pig face": "🐷",
  pig: "🐖",
  boar: "🐗",
  "pig nose": "🐽",
  sheep: "🐑",
  goat: "🐐",
  camel: "🐪",
  "two-hump camel": "🐫",
  llama: "🦙",
  giraffe: "🦒",
  elephant: "🐘",
  rhinoceros: "🦏",
  hippopotamus: "🦛",
  "mouse face": "🐭",
  mouse: "🐁",
  rat: "🐀",
  hamster: "🐹",
  "rabbit face": "🐰",
  rabbit: "🐇",
  chipmunk: "🐿️",
  beaver: "🦫",
  hedgehog: "🦔",
  bat: "🦇",
  bear: "🐻",
  koala: "🐨",
  panda: "🐼",
  sloth: "🦥",
  otter: "🦦",
  skunk: "🦨",
  kangaroo: "🦘",
  badger: "🦡",
  "paw prints": "🐾",
  "pile of poo": "💩",
  turkey: "🦃",
  chicken: "🐔",
  rooster: "🐓",
  "hatching chick": "🐣",
  "baby chick": "🐤",
  "front-facing baby chick": "🐥",
  bird: "🐦",
  penguin: "🐧",
  dove: "🕊️",
  eagle: "🦅",
  duck: "🦆",
  swan: "🦢",
  owl: "🦉",
  flamingo: "🦩",
  peacock: "🦚",
  parrot: "🦜",
  frog: "🐸",
  crocodile: "🐊",
  turtle: "🐢",
  lizard: "🦎",
  snake: "🐍",
  "dragon face": "🐲",
  dragon: "🐉",
  sauropod: "🦕",
  "t-rex": "🦖",
  whale: "🐳",
  dolphin: "🐬",
  seal: "🦭",
  fish: "🐟",
  "tropical fish": "🐠",
  blowfish: "🐡",
  shark: "🦈",
  octopus: "🐙",
  coral: "🪸",
  snail: "🐌",
  butterfly: "🦋",
  bug: "🐛",
  ant: "🐜",
  honeybee: "🐝",
  beetle: "🪲",
  "lady beetle": "🐞",
  cricket: "🦗",
  cockroach: "🪳",
  spider: "🕷️",
  "spider web": "🕸️",
  scorpion: "🦂",
  mosquito: "🦟",
  fly: "🪰",
  worm: "🪱",
  microbe: "🦠",
  bouquet: "💐",
  "cherry blossom": "🌸",
  "white flower": "💮",
  rosette: "🏵️",
  rose: "🌹",
  "wilted flower": "🥀",
  hibiscus: "🌺",
  sunflower: "🌻",
  blossom: "🌼",
  tulip: "🌷",
  seedling: "🌱",
  "potted plant": "🪴",
  "evergreen tree": "🌲",
  "deciduous tree": "🌳",
  "palm tree": "🌴",
  cactus: "🌵",
  "sheaf of rice": "🌾",
  herb: "🌿",
  shamrock: "☘️",
  "four leaf clover": "🍀",
  "maple leaf": "🍁",
  "fallen leaf": "🍂",
  "leaf fluttering in wind": "🍃",
  grapes: "🍇",
  melon: "🍈",
  watermelon: "🍉",
  tangerine: "🍊",
  lemon: "🍋",
  banana: "🍌",
  pineapple: "🍍",
  mango: "🥭",
  apple: "🍎",
  "green apple": "🍏",
  pear: "🍐",
  peach: "🍑",
  cherries: "🍒",
  strawberry: "🍓",
  blueberries: "🫐",
  kiwi: "🥝",
  tomato: "🍅",
  olive: "🫒",
  coconut: "🥥",
  avocado: "🥑",
  eggplant: "🍆",
  potato: "🥔",
  carrot: "🥕",
  corn: "🌽",
  "hot pepper": "🌶️",
  "bell pepper": "🫑",
  cucumber: "🥒",
  "leafy green": "🥬",
  broccoli: "🥦",
  garlic: "🧄",
  onion: "🧅",
  mushroom: "🍄",
  peanuts: "🥜",
  chestnut: "🌰",
  bread: "🍞",
  croissant: "🥐",
  "baguette bread": "🥖",
  pretzel: "🥨",
  bagel: "🥯",
  pancakes: "🥞",
  waffle: "🧇",
  "cheese wedge": "🧀",
  "meat on bone": "🍖",
  "poultry leg": "🍗",
  "cut of meat": "🥩",
  bacon: "🥓",
  hamburger: "🍔",
  "french fries": "🍟",
  pizza: "🍕",
  "hot dog": "🌭",
  sandwich: "🥪",
  taco: "🌮",
  burrito: "🌯",
  tamale: "🫔",
  "stuffed flatbread": "🥙",
  falafel: "🧆",
  egg: "🥚",
  cooking: "🍳",
  "shallow pan of food": "🥘",
  "pot of food": "🍲",
  "bowl with spoon": "🥣",
  "green salad": "🥗",
  popcorn: "🍿",
  butter: "🧈",
  salt: "🧂",
  "canned food": "🥫",
  sun: "☀️",
  cloud: "☁️",
  "sun behind cloud": "⛅",
  "sun behind rain cloud": "🌦️",
  "cloud with rain": "🌧️",
  "cloud with lightning and rain": "⛈️",
  "cloud with lightning": "🌩️",
  "cloud with snow": "🌨️",
  snowflake: "❄️",
  snowman: "☃️",
  "snowman without snow": "⛄",
  comet: "☄️",
  fire: "🔥",
  droplet: "💧",
  "water wave": "🌊",
  rainbow: "🌈",
  umbrella: "☂️",
  "soccer ball": "⚽",
  basketball: "🏀",
  football: "🏈",
  baseball: "⚾",
  softball: "🥎",
  tennis: "🎾",
  volleyball: "🏐",
  "rugby football": "🏉",
  "flying disc": "🥏",
  boomerang: "🪃",
  "ping pong": "🏓",
  badminton: "🏸",
  hockey: "🏒",
  "field hockey": "🏑",
  lacrosse: "🥍",
  "cricket game": "🏏",
  trophy: "🏆",
  medal: "🏅",
  "first place medal": "🥇",
  "second place medal": "🥈",
  "third place medal": "🥉",
  "check mark": "✅",
  "check mark button": "✅",
  "cross mark": "❌",
  "cross mark button": "❌",
  heart: "❤️",
  "red heart": "❤️",
  "orange heart": "🧡",
  "yellow heart": "💛",
  "green heart": "💚",
  "blue heart": "💙",
  "purple heart": "💜",
  "black heart": "🖤",
  "white heart": "🤍",
  "brown heart": "🤎",
  "broken heart": "💔",
  "growing heart": "💗",
  "beating heart": "💓",
  "revolving hearts": "💞",
  "two hearts": "💕",
  "heart decoration": "💟",
  star: "⭐",
  sparkles: "✨",
  wave: "👋",
  "high five": "✋",
  warning: "⚠️",
  "no entry": "⛔",
  question: "❓",
  exclamation: "❗",
  "100": "💯",
  "arrow up": "⬆️",
  "arrow down": "⬇️",
  "arrow left": "⬅️",
  "arrow right": "➡️",
  "stop sign": "🛑",
  recycle: "♻️",
  copyright: "©️",
  registered: "®️",
  trademark: "™️",
  sparkle: "✨",
  skull: "💀",
  "sparkling heart": "💖",
  "face holding back tears": "🥹",
  "hundred points": "💯",
  "rolling eyes face": "🙄",
  "raised hands": "🙌",
  "person facepalming": "🤦",
  "person shrugging": "🤷",
  camera: "📸",
  "birthday cake": "🎂",
  gift: "🎁",
  balloon: "🎈",
  "party popper": "🎉",
  "confetti ball": "🎊",
  "christmas tree": "🎄",
  clock: "⏰",
  "alarm clock": "⏰",
  hourglass: "⌛",
  rocket: "🚀",
  telephone: "📞",
  "mobile phone": "📱",
  laptop: "💻",
  television: "📺",
  "camera with flash": "📸",
  "video camera": "📹",
  "movie camera": "🎥",
  "light bulb": "💡",
  books: "📚",
  book: "📖",
  newspaper: "📰",
  memo: "📝",
  envelope: "✉️",
  "e-mail": "📧",
  "incoming envelope": "📨",
  lock: "🔒",
  unlock: "🔓",
  key: "🔑",
  hammer: "🔨",
  knife: "🔪",
  "crystal ball": "🔮",
  calendar: "📅",
  "chart increasing": "📈",
  "chart decreasing": "📉",
  clipboard: "📋",
  pushpin: "📌",
  link: "🔗",
  dollar: "💵",
  "credit card": "💳",
  "gem stone": "💎",
  crown: "👑",
  "musical note": "🎵",
  "musical notes": "🎶",
  headphone: "🎧",
  "game die": "🎲",
  "puzzle piece": "🧩",
  "direct hit": "🎯",
  art: "🎨",
  thread: "🧵",
  glasses: "👓",
  necktie: "👔",
  boots: "👢",
  ring: "💍",
  lipstick: "💄",
  "kiss mark": "💋",
};

export interface EmojiOption {
  emoji: string;
  label: string;
}

const normalizeShortcodeKey = (value: string): string =>
  value.toLowerCase().trim().replace(/[_-]+/g, " ").replace(/\s+/g, " ");

const normalizedShortcodeMap: Record<string, string> = Object.fromEntries(
  Object.entries(shortcodeMap).map(([key, emoji]) => [
    normalizeShortcodeKey(key),
    emoji,
  ]),
);

export const replaceEmojiShortcodes = (input: string): string => {
  if (!input.includes(":")) {
    return input;
  }

  return input.replace(/:([a-zA-Z0-9_\s-]+):/g, (match, rawName: string) => {
    const normalized = normalizeShortcodeKey(rawName);
    return normalizedShortcodeMap[normalized] ?? match;
  });
};

export const emojiOptions: EmojiOption[] = Array.from(
  Object.entries(shortcodeMap)
    .reduce<Map<string, EmojiOption>>((acc, [label, emoji]) => {
      if (!acc.has(emoji)) {
        acc.set(emoji, { label, emoji });
      }
      return acc;
    }, new Map())
    .values(),
);
